// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_b3jVI","box":"index_box_1MLBk","close":"index_close_v8WOo","page":"index_page_JU4oA"};